import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    AppBar,
    Toolbar,
    Typography,
    Button,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Tooltip,
} from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useThemeContext } from '../context/ThemeContext';

function Header({ title }) {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { user, logout, hasRole } = useAuth();
    const { isDarkMode, toggleTheme } = useThemeContext();

    const handleChangeLanguage = (event) => {
        i18n.changeLanguage(event.target.value);
    };

    const isOnPage = (path) => location.pathname.startsWith(path);
    const isAdmin = hasRole('ROLE_ADMIN');

    return (
        <AppBar position="static">
            <Toolbar>
                <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                    {title}
                </Typography>
                <Typography variant="body1" sx={{ mr: 2 }}>
                    {t('common.welcome')}, {user?.name || user?.username}!
                </Typography>

                {!isOnPage('/dashboard') && (
                    <Button sx={{ mr: 1 }} color="inherit" onClick={() => navigate('/dashboard')}>
                        {t('common.dashboard')}
                    </Button>
                )}

                {!isOnPage('/graph') && (
                    <Button sx={{ mr: 1 }} color="inherit" onClick={() => navigate('/graph')}>
                        {t('common.graph')}
                    </Button>
                )}

                {!isOnPage('/monthly-averages') && (
                    <Button sx={{ mr: 1 }} color="inherit" onClick={() => navigate('/monthly-averages')}>
                        {t('common.monthlyAverages')}
                    </Button>
                )}

                {!isOnPage('/power-cost') && (
                    <Button sx={{ mr: 1 }} color="inherit" onClick={() => navigate('/power-cost')}>
                        {t('common.powerCost')}
                    </Button>
                )}

                {isAdmin && !isOnPage('/admin') && (
                    <Button sx={{ mr: 1 }} color="inherit" onClick={() => navigate('/admin')}>
                        {t('common.admin')}
                    </Button>
                )}

                <Button sx={{ mr: 1 }} color="inherit" onClick={logout}>
                    {t('common.logout')}
                </Button>

                <Tooltip title={isDarkMode ? t('common.lightMode') : t('common.darkMode')}>
                    <IconButton color="inherit" onClick={toggleTheme} sx={{ mr: 1 }}>
                        {isDarkMode ? <LightMode /> : <DarkMode />}
                    </IconButton>
                </Tooltip>

                <FormControl variant="standard" sx={{ m: 1, minWidth: 80 }}>
                    <InputLabel id="language-select-label" sx={{ color: 'white' }}>
                        {t('common.language')}
                    </InputLabel>
                    <Select
                        labelId="language-select-label"
                        id="language-select"
                        value={i18n.language ? i18n.language.split('-')[0] : 'en'}
                        onChange={handleChangeLanguage}
                        label={t('common.language')}
                        sx={{ color: 'white' }}
                    >
                        <MenuItem value="en">English</MenuItem>
                        <MenuItem value="it">Italiano</MenuItem>
                    </Select>
                </FormControl>
            </Toolbar>
        </AppBar>
    );
}

export default Header;
